import { useFieldArray, useFormContext } from 'react-hook-form';
import { array } from 'fp-ts';
import { Banner, Button, IconName, Stack, StackItem, Typography } from '@optimus-web/core';
import { lt } from '@mews/framework';
import { PolicyExceptionFormValues } from '../../../../../schemas';
import { PolicyExceptionsDatesFieldName, FieldSectionName } from '../../../types';
import { MAX_NUMBER_OF_TIME_INTERVALS } from '../../../constants';
import { PolicyExceptionsDateIntervalRow } from './PolicyExceptionsDateIntervalRow';

export const PolicyExceptionsFormDatesFields = () => {
    const { control } = useFormContext<PolicyExceptionFormValues>();
    const { fields, append, remove } = useFieldArray({
        name: `${FieldSectionName.Dates}.${PolicyExceptionsDatesFieldName.TimeUnitIntervals}`,
        control,
    });

    const hasReachedMaxNumberOfTimeIntervals = array.size(fields) >= MAX_NUMBER_OF_TIME_INTERVALS;

    return (
        <Stack vertical spacing="300">
            <Stack vertical spacing="150">
                <Stack vertical spacing="100">
                    <Typography textStyle="titleSmallStrong" as="div">
                        {lt('PolicyExceptionFormDatesTitle')}
                    </Typography>
                    <Typography textStyle="bodyMedium" variant="secondary" as="div">
                        {lt('PolicyExceptionFormDatesDescription')}
                    </Typography>
                </Stack>
                {fields.map(({ id }, index) => (
                    <PolicyExceptionsDateIntervalRow
                        disabled={array.size(fields) === 1 && index === 0}
                        index={index}
                        onRemove={() => remove(index)}
                        key={id}
                    />
                ))}
            </Stack>
            <StackItem grow={false}>
                <Button
                    disabled={hasReachedMaxNumberOfTimeIntervals}
                    icon={IconName.Add}
                    onClick={() => append({ firstTimeUnitStartUtc: null, lastTimeUnitStartUtc: null })}
                    type="button"
                >
                    {lt('PolicyExceptionFormAddDateButtonLabel')}
                </Button>
            </StackItem>
            {hasReachedMaxNumberOfTimeIntervals ? (
                <Banner primaryText={lt('PolicyExceptionMaxTimeIntervalBannerDescription')} variant="info" />
            ) : null}
        </Stack>
    );
};
